import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import store, { persistor } from './store';
import App from './App';
import './index.css';

// React Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

// ToastContainer için tema senkronizasyonu
// HTML'deki 'dark' class'ını dinleyerek otomatik tema değişimi sağlar
const getToastTheme = () => {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
};

// MutationObserver ile HTML class değişikliklerini dinle
const observer = new MutationObserver(() => {
  const toastContainer = document.querySelector('.Toastify');
  if (toastContainer) {
    // Tema değiştiğinde mevcut toast'ların görünümünü güncelle
    const isDark = document.documentElement.classList.contains('dark');
    toastContainer.setAttribute('data-theme', isDark ? 'dark' : 'light');
  }
});

// DOM hazır olduğunda observer'ı başlat
if (typeof window !== 'undefined') {
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <App />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={getToastTheme()}
          />
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </StrictMode>
);
